<template>
  <div class="dropdown" @mouseleave="hideMenu">
    <span class="dropdown-show" @mouseenter="showMenu">做同款</span>
    <transition>
      <div
        class="dropdown-menu"
        v-show="isShowDrowdown"
        ref="menu"
        :style="menuStyle"
        @mouseenter="showMenu"
      >
        <span class="item" v-for="item of menus" :key="item.enName">
          <router-link v-if="item.isInnerJump" class="draw-link" :to="item.path">{{ item.name }}</router-link>
          <a v-else class="draw-link" :href="item.path">{{ item.name }}</a>
        </span>
      </div>
    </transition>
  </div>
</template>
<script>
import { getDesignNavs, hasMaterialId } from "@/assets/scripts/common";

export default {
  props: {
    designData: {
      type: Object,
      default: () => {},
    },
    designName: {
      type: String,
      default: "",
    },
  },
  data: () => ({
    isShowDrowdown: false,
    menuStyle: {},
  }),
  computed: {
    menus() {
      return this.genMenus();
    },
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.hideMenu, true);
  },
  methods: {
    showMenu() {
      this.isShowDrowdown = true;
      this.$nextTick(this.updateMenuPosition);
      window.addEventListener("scroll", this.hideMenu, true);
    },
    hideMenu() {
      this.isShowDrowdown = false;
      window.removeEventListener("scroll", this.hideMenu, true);
    },
    updateMenuPosition() {
      const trigger = this.$el && this.$el.querySelector(".dropdown-show");
      const menuEl = this.$refs.menu;
      if (!trigger) return;
      const rect = trigger.getBoundingClientRect();
      const menuHeight = (menuEl && menuEl.offsetHeight) || this.menus.length * 28 + 10;
      const openUp = rect.top >= menuHeight || rect.top > window.innerHeight - rect.bottom;
      this.menuStyle = {
        position: "fixed",
        zIndex: 3000,
        right: `${window.innerWidth - rect.right}px`,
        left: "auto",
        top: openUp ? "auto" : `${rect.bottom}px`,
        bottom: openUp ? `${window.innerHeight - rect.top}px` : "auto",
      };
    },
    getPopupMaterial() {
      const popupData = this.designData && this.designData.popupData;
      if (!Array.isArray(popupData)) return null;
      return popupData.find(block => block.blockName === "material") || null;
    },
    buildSameStyleQuery() {
      const data = this.designData || {};
      const popupMaterial = this.getPopupMaterial();
      const backgroundId = data.backgroundId;
      const elementId = data.elementId;
      const elementTypeId = data.elementTypeId;
      const tagId = data.tagId;
      const backgroundSrc = data.backgroundSrc || (data.bgParameter && data.bgParameter.src) || "";
      const tagBgColor = data.bgParameter && data.bgParameter.tagBgColor;
      const textShadowColor = data.bgParameter && data.bgParameter.textShadowColor;
      const elementSrc =
        data.elementSrc || data.elementImg || (popupMaterial && popupMaterial.elementInfo && popupMaterial.elementInfo.src) || "";
      const params = new URLSearchParams();
      if (hasMaterialId(backgroundId) || backgroundSrc) {
        if (hasMaterialId(backgroundId)) params.set("bId", backgroundId);
        if (backgroundSrc) params.set("bSrc", backgroundSrc);
        if (tagBgColor) params.set("tagBgColor", tagBgColor);
        if (textShadowColor) params.set("textShadowColor", textShadowColor);
      }
      if (hasMaterialId(elementId) || elementSrc) {
        if (hasMaterialId(elementId)) params.set("eId", elementId);
        if (elementSrc) params.set("eSrc", elementSrc);
        if (hasMaterialId(elementTypeId)) params.set("eTypeId", elementTypeId);
      }
      if (hasMaterialId(tagId)) params.set("tagId", tagId);
      return params;
    },
    appendQuery(link, extraParams) {
      const [path, existing = ""] = (link || "").split("?");
      const params = new URLSearchParams(existing);
      extraParams.forEach((value, key) => {
        if (value) params.set(key, value);
      });
      const qs = params.toString();
      return qs ? `${path}?${qs}` : path;
    },
    genMenus() {
      const extraParams = this.buildSameStyleQuery();
      return getDesignNavs()
        .filter(item => item.value !== this.designName)
        .map(item => {
          const params = new URLSearchParams(extraParams.toString());
          let path = item.link;
          if (item.isInnerJump && !String(path).includes("rebuild=")) {
            params.set("rebuild", "true");
          }
          path = this.appendQuery(path, params);
          return {
            enName: item.value,
            name: item.listName,
            path,
            isInnerJump: item.isInnerJump,
          };
        });
    },
  },
};
</script>
<style lang="scss" scoped>
.dropdown {
  position: relative;
  width: 64px;
  height: 44px;
  padding-top: 8px;
  .dropdown-show {
    display: block;
    border-radius: 22px;
    font-size: 12px;
    border: 1px solid #6d7278;
    background: #fff;
    text-align: center;
    line-height: 26px;
    height: 28px;
    color: #183b56;
    cursor: pointer;
    &:hover {
      color: #3f69f9;
    }
  }
  .dropdown-menu {
    padding: 5px 0;
    position: absolute;
    min-width: 88px;
    bottom: 100%;
    right: 0;
    border-radius: 8px;
    background: #fff;
    box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);
    overflow: visible;
    z-index: 20;
    .item {
      display: block;
    }
    .draw-link {
      display: block;
      height: 28px;
      text-align: center;
      line-height: 28px;
      color: #183b56;
      font-weight: 500;
      cursor: pointer;
      font-size: 12px;
      &:hover {
        color: #3f69f9;
      }
    }
  }
}
</style>
